module.exports = __webpack_public_path__ + "static/media/icon_training.ca6448be.svg";